<template>
    <div class="institutionList">
        <div class="header">
            <el-row>
                <el-col :span="8">
                    <label class="headerlabel">机构名称</label>
                    <el-input v-model="param.orgName" placeholder="请输入机构名称" class="autowidth" clearable ></el-input>
                </el-col>
                <el-col :span="16">
                    <label class="headerlabel">审批状态</label>
                    <el-select v-model="param.isActive" placeholder="请选择" class="autowidth" clearable >
                        <el-option label="审批中" :value="0"></el-option>
                        <el-option label="已通过" :value="1"></el-option>
                        <el-option label="已拒绝" :value="2"></el-option>
                    </el-select>
                    <el-button type="primary" style="margin-left: 24px;" @click="handleinitialization(1)">筛选</el-button>
                    <el-button @click="reaset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-table
            :data="institutionListData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%">
                <el-table-column prop="organizationId" label="机构ID" width="50"></el-table-column>
                <el-table-column label="logo">
                    <template slot-scope="scope">
                        <img :src="scope.row.orgLogo" style="width: 40px;height: 40px;border-radius: 50%;">
                    </template>
                </el-table-column>
                <el-table-column prop="orgName" label="机构名称"></el-table-column>
                <el-table-column prop="corporateName" label="法人姓名"></el-table-column>
                <el-table-column prop="practicingTime" label="执业年限"></el-table-column>
                <el-table-column prop="province" label="所在省份"></el-table-column>
                <el-table-column prop="address" label="地址"></el-table-column>
                <el-table-column prop="contactTel" label="手机号"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column prop="licenseNumber" label="执照编号"></el-table-column>
                <el-table-column  label="审批状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isActive==0">审批中</el-tag>
                        <el-tag type="success" v-else-if="scope.row.isActive==1">已通过</el-tag>
                        <el-tag type="danger" v-else>已拒绝</el-tag>
                        
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" v-if="scope.row.isActive==0" @click="examine(scope.row)">审批</el-button>
                        <el-button type="text" style="margin:0 10px;" v-if="scope.row.orgCode" @click="$router.push('institution?organizationId='+scope.row.orgCode)">查看</el-button>
                        <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row.organizationId)">
                            <el-button type="text" style="color: #F24B4E;" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageNum"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <!-- 咨询师认证 -->
        <el-dialog
            title="机构认证审批"
            :visible.sync="dialogVisible"
            width="520px"
            :before-close="handleClose">
            <el-form label-width="100px" class="dialogform">
                <el-form-item label="机构名称:">{{Detail.orgName}}</el-form-item>
                <el-form-item label="logo:">
                    <el-image style="width: 100px; height: 100px;" :src="Detail.orgLogo" fit="contain"></el-image>
                </el-form-item>
                <el-form-item label="地址:">{{Detail.address}}</el-form-item>
                <el-form-item label="法人:">{{Detail.corporateName}}</el-form-item>
                <el-form-item label="资质信息:">
                    <el-image style="width: 100px; height:75px" :src="item" fit="contain" v-for="item in Detail.qualifications"></el-image>
                </el-form-item>
                <el-form-item label="创建时间:">{{Detail.createTime}}</el-form-item>
            </el-form>
            <div class="item">
                <label>审批状态：</label> <span>待审批</span>
            </div>
            <div class="item">
                <label>拒绝原因：</label>
                <el-input
                style="width: 410px;"
                type="textarea"
                :rows="3"
                placeholder="仅需在拒绝时需要填写"
                v-model="Detail.reason">
                </el-input>
            </div>
            <div style="text-align: right;">
                <el-button @click="handleClose">取消</el-button>
                <el-button @click="submit(2)">拒绝</el-button>
                <el-button type="primary" @click="submit(1)">同意申请</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            dialogVisible:false,
            loading:false,
            param:{
                pageNum:1,
                pageSize:10,
                PageTotal:0,
                orgName:'',
                isActive:''
            },
            institutionListData: [],
            Detail:{}
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init(){
            this.loading=true;
            this.$Http_Post('/basic/Organization/list',this.param).then(res=>{
                if(res.Code==0){
                    this.institutionListData=res.Data;
                    this.param.PageTotal=res.Counts;
                }else{
                    this.$message.error(res.Message);
                }
                this.loading=false;
            })
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init()
        },
        handleClose(){
            this.dialogVisible=false;
        },
        examine(e){
            this.dialogVisible=true;
            this.Detail=e;
        },
        // 删除
        confirm(e){
            this.$Http_Post('/basic/Organization/remove/'+e).then(res=>{
                if(res.Code==0){
                    this.$message.success(res.Message);
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        submit(e){
            this.Detail.isActive=e;
            this.$Http_Post('/basic/Organization/edit',this.Detail).then(res=>{
                if(res.Code==0){
                    this.$message.success(res.Message);
                    this.dialogVisible=false;
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 重置
        reaset(){
            this.param=this.$options.data().param;
            this.init();
        }
    },
}
</script>
<style>
.institutionList .header{background: #fff;padding:20px;}
.institutionList .header .headerlabel{width:90px;display: inline-block;}
.institutionList .header .autowidth{width: 240px;}
.institutionList .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.institutionList .dialogform{background: #F5F7FA;padding: 10px;border-radius: 4px;}
.institutionList .item{margin: 10px 0;display: flex;}
.institutionList .el-form-item{margin-bottom: 0;}
</style>